import React from 'react';
import Layout from 'components/containers/PrivateLayout';
import Subscription from 'components/containers/Subscription';

export default () => (
  <Layout>
    <Subscription />
  </Layout>
);
